import { render } from "./PublicBoard.vue?vue&type=template&id=6a1dc196&scoped=true"
import script from "./PublicBoard.vue?vue&type=script&lang=js"
export * from "./PublicBoard.vue?vue&type=script&lang=js"

import "./PublicBoard.vue?vue&type=style&index=0&id=6a1dc196&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a1dc196"]])

export default __exports__